<template>
  <div :style="contentStyle">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    data(){
      return {
        winHeight: ''
      }
    },
    computed: {
      contentStyle: function () {
        return {height: (this.winHeight - this.$store.state.contentMarginTop - this.$store.state.contentMarginBottom) + 'px', position: 'relative', minHeight: '521px'}
      }
    },
    methods: {
      onResize(){
        this.winHeight = window.innerHeight;
      },
      preventTouchMove(){
        this.$el.addEventListener('touchmove', function (event) {
          //event.preventDefault();
        });
      }
    },
    created(){
      this.onResize();
    },
    mounted(){
      window.addEventListener('resize', this.onResize);
      this.onResize();
      this.preventTouchMove();
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?0ba380d6